module.exports = __webpack_public_path__ + "static/media/slideshow-29.b40de4ff.jpg";